import {Frequency, FrequencyType} from './frequency';

export class ProductRatings {

  averages: RatingAverages;
  frequencyDistributionList: Frequency[] = [];
  frequencyCount = 0;

  constructor(public data: any) {
    if (data) {
      const json: JSON = data;

      if (json['averages']) {
        this.averages = new RatingAverages(json['averages']);
      }

      if (json['frequencyDistribution']) {
        let total = 0;
        for (const frequency of json['frequencyDistribution']) {
          this.frequencyDistributionList.push(new Frequency(frequency, FrequencyType.Product));
          total = total + frequency.count;
        }

        this.frequencyCount = total;

        // calculate the frequency percentages
        for (const freq of this.frequencyDistributionList) {
          freq.percentageString = Math.round((freq.count / total) * 100) + '%';
        }
      }
    }
  }
}

export class RatingAverages {

  averageScore: number;
  ratingsCount: string;
  averageStarRating: number;

  constructor(public data: any) {
    if (data) {
      const json: JSON = data;

      this.averageScore = json['ratingAverage'];
      this.ratingsCount = json['ratingsCount'];
      this.averageStarRating = json['starAverage'];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/model/product-ratings.ts